import React from 'react';
import { FormGroup, Label, Input, Col, Row } from 'reactstrap';
import Select from 'react-select';

export const IntegerAndRealNumbersForm = (props) => {

    const {
        activeTab, isSimple, changeUnit,
        id_type_analyte, id_unit, id_unit_to,
        units, unitsTo,
        handleInputChange
    } = props;

   const optionsUnits = [
    { value: 0, label: "Selecciona una opción" },
    ...(Array.isArray(units)
        ? units.map(u => ({
            value: u.id_unit,
            label: `${u.unit} (${u.abbreviation})`
        }))
        : []
    )
];
    return (
        <>
           {isSimple ? (
            <>
                    <Col sm={id_type_analyte === "2" ? 6 : id_type_analyte === "3" ? 4 : id_type_analyte === "7" ? 4 : 12}>
                        <FormGroup className={`mb-3 ${ (id_type_analyte === "2" || id_type_analyte === "3" || id_type_analyte === "4" || id_type_analyte === "5" || id_type_analyte === "6" || id_type_analyte === "7")    ? "" : "d-none" }`} >
                            <Label className="text-sm">Unidad de origen </Label>
                            {/* <Input disabled={activeTab === 2} className="form-control form-control-sm input-air-primary" 
                            bsSize="sm" type="select" name="id_unit" value={id_unit} onChange={(e) => changeUnit(e)} required={true} >
                                <option value={0}>Selecciona una opción</option>
                                    {units.length > 0 &&
                                        units.map((u, key) => (
                                        <option key={key} value={u.id_unit}>
                                            {`${u.unit} (${u.abbreviation})`}
                                        </option>
                                    ))}
                            </Input> */}
                            <Select
                                isDisabled={activeTab === 2}
                                options={optionsUnits}
                                value={optionsUnits.find(opt => opt.value === id_unit) || null}
                                onChange={(selected) => {
                                    changeUnit({
                                        target: {
                                            name: "id_unit",
                                            value: selected?.value || 0
                                        }
                                    });
                                }}
                                placeholder="Selecciona una opción"
                                className="react-select-container"/>
   
                        </FormGroup>
                    </Col>

                    {/* <Col xs="12" sm="6" md="6" lg="6" xl="6">
                        <FormGroup className={`mb-3 ${ (id_type_analyte === "2" || id_type_analyte === "3") ? "" : "d-none" }`} >
                            <Label className="text-sm">Unidad de destino1</Label> 
                            <Input disabled={activeTab === 2} className="form-control form-control-sm input-air-primary" bsSize="sm" type="select" name="id_unit_to" value={id_unit_to} onChange={handleInputChange} required={true} >
                                <option value={0}>Selecciona una opción</option>
                                {unitsTo.length > 0 &&
                                    unitsTo.map((u, key) => (
                                    <option key={key} value={u.id_unit_to}>
                                        {`${u.name_unit_to} (${u.abbreviation_unit_to})`}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col> */}
                </>
                ) : (
                <>
                   <Col
                    sm={id_type_analyte === "2" ? 6 : id_type_analyte === "3" ? 4 : id_type_analyte === "7" ? 4 : 12}
                >

                        <FormGroup className={`mb-3 ${ (id_type_analyte === "2" || id_type_analyte === "3" || id_type_analyte === "4" || id_type_analyte === "5" || id_type_analyte === "6" || id_type_analyte === "7") ? "" : "d-none" }`} >
                            <Label className="text-sm">Unidad &nbsp;&nbsp;&nbsp;&nbsp;</Label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            {/* <Input disabled={activeTab === 2} className="form-control form-control-sm input-air-primary" 
                            bsSize="sm" type="select" name="id_unit" value={id_unit} onChange={(e) => changeUnit(e)}required={true} >
                                <option value={0}>Selecciona una opción</option>
                                {units.length > 0 &&
                                    units.map((u, key) => (
                                    <option key={key} value={u.id_unit}>
                                        {`${u.unit} (${u.abbreviation})`}
                                    </option>
                                    ))}
                            </Input> */}


                            <Select
                                isDisabled={activeTab === 2}
                                options={optionsUnits}
                                value={optionsUnits.find(opt => opt.value === id_unit) || null}
                                onChange={(selected) => {
                                    changeUnit({
                                        target: {
                                            name: "id_unit",
                                            value: selected?.value || 0
                                        }
                                    });
                                }}
                                placeholder="Selecciona una opción"
                                className="react-select-container"
                                classNamePrefix="react-select"

                                 styles={{
                                    menuPortal: base => ({ ...base, zIndex: 99999999 }),
                                    control: (base, state) => ({
                                        ...base,
                                        borderRadius: '8px',
                                        padding: '1px',
                                        fontSize: '13px',
                                        boxShadow: state.isFocused ? '0 0 0 1px #0569ff' : 'none',
                                        '&:hover': {
                                            borderColor: '#0569ff'
                                        }
                                    })
                                }}
                            />

                        </FormGroup>
                    </Col>
{/* 
                    <Col xs="12">
                    <FormGroup
                        className={`mb-3 ${
                        (id_type_analyte === "2" || id_type_analyte === "3") ? "" : "d-none"
                        }`}
                    >
                        <Label className="text-sm">Unidad de destino</Label>
                        <Input
                        disabled={activeTab === 2}
                        className="form-control form-control-sm input-air-primary"
                        bsSize="sm"
                        type="select"
                        name="id_unit_to"
                        value={id_unit_to}
                        onChange={handleInputChange}
                        required={true}
                        >
                        <option value={0}>Selecciona una opción</option>
                        {unitsTo.length > 0 &&
                            unitsTo.map((u, key) => (
                            <option key={key} value={u.id_unit_to}>
                                {`${u.name_unit_to} (${u.abbreviation_unit_to})`}
                            </option>
                            ))}
                        </Input>
                    </FormGroup>
                    </Col> */}
                </>
            )}


        </>
    )
}
